<script>
/* COMPOSANTS */
import MultiSelect from 'primevue/multiselect';
import AkInputText from '@components/v2/input/AkInputText.vue';
import AkAutocomplete from '@components/v2/input/AkAutocomplete.vue';
import AkCalendar from '@components/v2/input/AkCalendar.vue';
import AkButtonFooterSidebarFilter from '@components/v2/general/AkButtonFooterSidebarFilter.vue';

/* MIXINS */
import permissionsMixin from '@mixins/permissionsMixin';
import utilsMixin from '@mixins/utilsMixin';
import sidebarMixin from '@mixins/sidebarMixin';
import companyMixin from '@mixins/companyMixin';
import accommodationAutocompleteMixin from '@mixins/autocomplete/accommodationAutocompleteMixin';
import reservationAutocompleteMixin from '@mixins/autocomplete/reservationAutocompleteMixin';

/* SERVICES */

export default {
  components: {
    AkButtonFooterSidebarFilter,
    MultiSelect,
    AkInputText,
    AkAutocomplete,
    AkCalendar,
  },
  mixins: [
    permissionsMixin,
    utilsMixin,
    sidebarMixin,
    companyMixin,
    accommodationAutocompleteMixin,
    reservationAutocompleteMixin,
  ],
  props: {
    modelValue: {required: true},
    callback: {
      type: Array,
      required: false,
      default: undefined,
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    itemSelect(item) {
      this.$nextTick(() => {
        this.callback[0]();
      });
    },
    search() {
      this.callback[0]();
      this.hideSidebar();
    },
    reset() {
      this.callback[1]();
      if (this.$refs.accommodationAutocomplete) this.$refs.accommodationAutocomplete.reset();
      if (this.$refs.reservationAutocomplete) this.$refs.reservationAutocomplete.reset();
    },
  },
  computed: {
    currentValue: {
      get: function () {
        return this.modelValue;
      },
      set: function (val) {
        this.$emit('update:modelValue', val);
      },
    },
    loadingCompanies() {
      return this.companies === undefined;
    },
  },
};
</script>

<template>
  <form class="flex flex-col gap-4" @submit.prevent>
    <MultiSelect
      v-if="this.isGas()"
      v-model="currentValue.companyIds"
      :loading="this.loadingCompanies"
      :options="this.companies"
      :placeholder="$t('employee.company')"
      class="form-control"
      filter
      filter-placeholder="Filtrer"
      option-label="name"
      option-value="id"
      @change="itemSelect" />
    <AkInputText v-model="currentValue.name" :placeholder="$t('role.traveller')" @valueChange="itemSelect" />
    <AkAutocomplete
      ref="accommodationAutocomplete"
      v-model="currentValue.accommodationId"
      :init-method="this.autocompleteAccommodationById"
      :inline="true"
      :placeholder="$t('accommodation_title')"
      :minLengthToLaunchSearch="3"
      :search-label="this.autocompleteAccommodationQuery"
      :search-method="this.autocompleteAccommodation"
      option-label="display"
      option-value="id"
      @item-select="itemSelect" />
    <AkAutocomplete
      ref="reservationAutocomplete"
      v-model="currentValue.reservationId"
      :init-method="this.autocompleteReservationById"
      :inline="true"
      :search-method="this.autocompleteReservation"
      :minLengthToLaunchSearch="3"
      label="Réservation"
      option-label="display"
      option-value="id"
      @item-select="itemSelect" />
    <AkInputText v-model="currentValue.email" :placeholder="$t('client.email')" @valueChange="itemSelect" />
    <AkInputText v-model="currentValue.phone" :placeholder="$t('client.phone')" @valueChange="itemSelect" />
    <AkCalendar
      v-model="currentValue.dateCreatedPeriod"
      :inline="true"
      @valueChange="itemSelect"
      :placeholder="$t('client.periodCreated')"
      date-format="dd/mm/yy"
      selection="range" />

    <AkButtonFooterSidebarFilter :validateLabel="$t('search.search')" @action="search()" @reset="reset()" />
  </form>
</template>
